export default function (name, maxchar = 20) {
  if (name && name.length > maxchar) {
    return name.substring(0, maxchar) + "&#8230;"
  }
  return name
}
